webpackJsonp([24],{

/***/ "XsNz":
/***/ (function(module, exports, __webpack_require__) {

var waveLandingAds = (function () {
    function waveLandingAds() {
    }
    return waveLandingAds;
}());
angular.module('animatronApp.wave.landingAds', []).component('waveLandingAds', {
    controller: waveLandingAds,
    templateUrl: __webpack_require__("gS/5")
});


/***/ }),

/***/ "gS/5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/wave-landing-ads_675217ebbc5df1a20ddc0012f74ca25d.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/24-82c0e6a2dceb23823569.min.js